import React, { useEffect, useState } from "react";
import SupplierService from "../Services/supplierService";
import PayableService from "../Services/payableService";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import customerService from "../Services/customerService";
import accountService from "../Services/accountService";
import Dropdown from "../Components/Dropdown";

const AddPayable = () => {
  const [suppliers, setSuppliers] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [isCustomerDropdownOpen, setCustomerDropdownOpen] = useState(false);

  const [data, setData] = useState({
    customer: "",
    number: "",
    bank: "",
    paying: "",
    payable: "",
    amount: "",
    note: "",
  });

  const [errors, setErrors] = useState({
    customer: false,
    number: false,
    bank: false,
    paying: false,
    payable: false,
    amount: false,
    note: false,
  });

  const [regex] = useState({
    customer: /.{1,50}$/,
    number: /.{1,50}$/,
    bank: /.{1,50}$/,
    paying: /.{1,50}$/,
    payable: /.{1,50}$/,
    amount: /.{1,50}$/,
    note: /.{1,50}$/,
  });

  const navigate = useNavigate();

  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        const supplierRes = await SupplierService.fetchAll();
        setSuppliers(supplierRes.suppliers || []);
      } catch (err) {
        console.error("Error fetching suppliers:", err);
      }

      try {
        const customerRes = await customerService.fetchAll();
        setCustomers(customerRes.customers || []);
      } catch (err) {
        console.error("Error fetching customers:", err);
      }

      try {
        const accountRes = await accountService.fetchAllActiveAccounts();
        setAccounts(accountRes.accounts || []);
      } catch (err) {
        console.error("Error fetching accounts:", err);
      }
    };

    fetchInitialData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: false }));
  };

  const submit = () => {
    let hasError = false;

    Object.keys(data).forEach((field) => {
      if (!regex[field]?.test(data[field])) {
        setErrors((prev) => ({ ...prev, [field]: true }));
        hasError = true;
      }
    });

    if (hasError) {
      toast.error("Please fill all the required fields");
      return;
    }

    PayableService.create(data)
      .then(() => navigate("/payable"))
      .catch((err) => {
        toast.error("Submission failed!");
        console.error(err);
      });
  };

  return (
    <main className="mx-10 my-2 p-6 rounded-3xl border border-gray-200 shadow-lg mb-20 bg-white">
      <p className="font-bold text-3xl text-secondary">Add Payable</p>

      <div className="mt-10">
        <div className="grid grid-cols-2 gap-2 md:grid-cols-4 md:gap-8">
          <div className="col-span-2">
            <label className="primary-label">Customer</label>
            <Dropdown
              style="!col-span-2"
              selected={data.customer}
              placeholder="Select Customer"
              onChange={(value) =>
                handleChange({ target: { name: "customer", value } })
              }
              options={customers.map((customer) => ({
                label: customer.company_name,
                value: customer.id,
              }))}
            />
          </div>

          <div>
            <label className="primary-label">Cheque No.</label>
            <input
              name="number"
              value={data.number}
              onChange={handleChange}
              placeholder="Cheque No."
              className={`primary-input ${
                errors["number"] ? "!border-red-600" : ""
              }`}
            />
          </div>

          <div>
            <label className="primary-label">Bank Name</label>
            <input
              name="bank"
              value={data.bank}
              onChange={handleChange}
              placeholder="Bank Name"
              className={`primary-input ${
                errors["bank"] ? "!border-red-600" : ""
              }`}
            />
          </div>
        </div>

        <div className="grid grid-cols-2 gap-2 md:grid-cols-3 md:gap-8 mt-4">
          <div>
            <label className="primary-label">Amount</label>
            <input
              name="amount"
              value={data.amount}
              onChange={handleChange}
              placeholder="Amount"
              className={`primary-input ${
                errors["amount"] ? "!border-red-600" : ""
              }`}
            />
          </div>

          <div>
            <label className="primary-label">Receiving Date</label>
            <input
              name="paying"
              value={data.paying}
              onChange={handleChange}
              type="date"
              className={`primary-input ${
                errors["paying"] ? "!border-red-600" : ""
              }`}
            />
          </div>

          <div>
            <label className="primary-label">Paying Date</label>
            <input
              name="payable"
              value={data.payable}
              onChange={handleChange}
              type="date"
              className={`primary-input ${
                errors["payable"] ? "!border-red-600" : ""
              }`}
            />
          </div>
        </div>

        <div className="grid grid-cols-1 mt-4">
          <div>
            <label className="primary-label">Note</label>
            <textarea
              name="note"
              value={data.note}
              onChange={handleChange}
              placeholder="Note"
              className={`primary-input ${
                errors["note"] ? "!border-red-600" : ""
              }`}
            />
          </div>
        </div>

        <div className="flex items-center justify-center mt-12">
          <button onClick={submit} className="button-primary">
            Add Payable
          </button>
        </div>
      </div>
    </main>
  );
};

export default AddPayable;
